// extracted by mini-css-extract-plugin
export default {"always":"WithdrawalFee_always","tooltip":"WithdrawalFee_tooltip"};